import GenericFilter, { Item } from "@/components/Filters/GenericFilter";
import { FaFistRaised } from "react-icons/fa";

export default function CostFilter({
  selected,
  setSelected,
}: {
  selected: Set<any>;
  setSelected: (selectedOptions: Set<string>) => void;
}) {
  let data: Item[] = [];
  for (let i = 0; i < 13; i++) {
    let power = i * 1000;
    data.push({ key: String(power), value: String(power) });
  }
  return (
    <GenericFilter
      classNames="w-28"
      selected={selected}
      setSelected={setSelected}
      startContent={<FaFistRaised className="h-[14px]" />}
      selectionMode="single"
      label="Power"
      data={data}
    />
  );
}
